import { render, staticRenderFns } from "./publicizeList.vue?vue&type=template&id=f1f09f1a&scoped=true"
import script from "./publicizeList.vue?vue&type=script&lang=js"
export * from "./publicizeList.vue?vue&type=script&lang=js"
import style0 from "./publicizeList.vue?vue&type=style&index=0&id=f1f09f1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f09f1a",
  null
  
)

export default component.exports